export default "__VITE_ASSET__CjkNflfw__"